import cxs from 'cxs';
import { COLOURS, SHADOWS } from '../../../common/styles/vars';
import { INPUT_STYLE_OBJECT } from '../../../common/styles/Input';

export const SAVE_BUTTON = cxs({
  width: '100%',
  marginTop: '20px',
  marginBottom: '10px',
  marginLeft: 'auto'
});

export const CONTENT = cxs({
  padding: '0px 10px',
  width: '100%',
  boxSizing: 'border-box'
});

export const WRAPPER = cxs({
  boxShadow: SHADOWS.soft,
  borderRadius: '6px',
  width: '220px',
  margin: '16px',
  overflow: 'hidden',
  background: 'white',

  '> .sketch-picker': {
    border: 'none !important',
    boxShadow: 'none !important',
    borderRadius: '0px !important',
    input: {
      borderRadius: '4px !important'
    },

    '> div:nth-child(3)': {
      '> div:first-child > div': {
        display: 'flex !important',
        flexDirection: 'column-reverse !important',
        alignItems: 'flex-start !important',

        '::after': {
          content: '"#"',
          position: 'absolute',
          left: '28px',
          top: '13px',
          fontSize: '14px',
          color: 'black'
        },

        '> input': {
          boxShadow: 'unset !important',
          ...INPUT_STYLE_OBJECT({ type: 'PRIMARY' }),
          border: `1px solid ${COLOURS.grey.mischka.russian} !important`,
          width: '100% !important',
          marginBottom: '10px',
          fontSize: '14px !important',
          paddingLeft: '40px !important',
          paddingRight: '20px !important',

          ':hover:not(:focus)': {
            border: `1px solid ${COLOURS.grey.regent} !important`
          },

          ':focus': {
            border: `1px solid ${COLOURS.grey.darkDenim} !important`
          }
        },

        '> span': {
          display: 'none !important'
        }
      },

      '> div:not(:first-child)': {
        display: 'none !important'
      }
    },

    '> div:last-child': {
      display: 'none !important'
    }
  },

  '> hr': {
    border: 'none',
    background: COLOURS.grey.athens.parthenon,
    height: '1px',
    width: 'calc(100% - 20px)',
    margin: '10px',
    marginTop: '5px'
  }
});